import { useMemo, useState } from "react"
import { observer } from "mobx-react"
import { Button, Flex, Table, Typography } from "antd"
import { ColumnsType } from "antd/es/table"
import {
  CopyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons"

import { IconCopy } from "@src/app/components/icons/copy"
import { notify } from "@src/app/components/notify"
import { paddingLimit } from "@src/shared/strings"

type Props = {
  data: Record<string, string>[]
  loading: boolean
}
export const CallBackUrlTable = observer(({ data, loading }: Props) => {
  const [isCallbackUrlHidden, setIsCallbackUrlHidden] = useState(true)

  const copyText = (text: string) => {
    navigator.clipboard.writeText(text)

    notify.success("Copied")
  }

  const icon = useMemo(
    () => (isCallbackUrlHidden ? <EyeOutlined /> : <EyeInvisibleOutlined />),
    [isCallbackUrlHidden],
  )

  const columns: ColumnsType<Record<string, string>> = [
    {
      align: "center",
      dataIndex: "callbackUrl",
      render: (_, { callbackUrl }) => (
        <Typography.Text>{callbackUrl}</Typography.Text>
      ),
      title: "Callback URL",
    },
    {
      align: "center",
      dataIndex: "signatureKey",
      render: (_, { signatureKey }) => (
        <Typography.Text>
          {isCallbackUrlHidden
            ? paddingLimit(signatureKey as string, 0, 8)
            : signatureKey}
        </Typography.Text>
      ),
      title: "Callback Signature Key",
      width: "40%",
    },
    {
      align: "center",
      render: (_, { signatureKey }) => (
        <Flex justify="center">
          <Button
            icon={icon}
            onClick={() => setIsCallbackUrlHidden(!isCallbackUrlHidden)}
            size="small"
            type="text"
          />

          <Button
            icon={<IconCopy height={14} width={14} />}
            onClick={() => copyText(signatureKey!)}
            size="small"
            type="text"
          />
        </Flex>
      ),
      title: "Actions",
    },
  ]

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={false}
    />
  )
})
